export const connectInnerCuttingLineClipPath = (self) => {
  const target_image_inner_wrapper_g_el =
    self._getTargetImageInnerWrapperGElThrowable();
  target_image_inner_wrapper_g_el.setAttributeNS(
    null,
    "clip-path",
    `url(#${self._inner_cutting_line_clip_path_id})`
  );
};
